import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  blogs: {
    data: [],
    meta: {
      total: 0,
    },
  },
  singleBlog: null,
};

export const createBlog = createAsyncThunk(
  "createBlog/blogs",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("blogs", data);
      enqueueSnackbar("Blog is added successfully");
      navigate(PATH_DASHBOARD.contents.blogs.list);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchBlogs = createAsyncThunk(
  "fetchBlogs/blogs",
  async ({ limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `blogs?limit=${limit}&page=${page + 1}`
      );
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const fetchSingleBlog = createAsyncThunk(
  "fetchSingleBlog/blogs",
  async ({ slug }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`blogs/${slug}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const updateBlog = createAsyncThunk(
  "updateBlog/blogs",
  async ({ slug, data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`blogs/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        slug,
        navigate,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "deleteBlog/blogs",
  async ({ id, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      await axiosInstance.delete(`blogs/${id}`);
      thunkApi.dispatch(fetchBlogs({ limit, page }));
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const blogSlice = createSlice({
  name: "blog",
  initialState,
  extraReducers: (builder) => {
    // TODO: create category
    builder.addCase(createBlog.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createBlog.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blogs.data = [action.payload, ...state.blogs.data];
      state.blogs.meta.total = state.blogs.meta.total + 1;
    });

    builder.addCase(createBlog.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch blog
    builder.addCase(fetchBlogs.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchBlogs.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.blogs = action.payload;
    });

    builder.addCase(fetchBlogs.rejected, (state, action) => {
      state.fetchLoading = false;
    });

    // ==========================

    // TODO: fetch single blog
    builder.addCase(fetchSingleBlog.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleBlog.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleBlog = action.payload;
    });

    builder.addCase(fetchSingleBlog.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update blog
    builder.addCase(updateBlog.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateBlog.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Blog is updated successfully");
      state.blogs.data = state.blogs.data.map((blog) =>
        blog.slug === action.payload.slug ? action.payload.data : blog
      );
      action.payload.navigate(PATH_DASHBOARD.contents.blogs.list);
    });

    builder.addCase(updateBlog.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete category
    builder.addCase(deleteBlog.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteBlog.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Blog is deleted successfully");
    });

    builder.addCase(deleteBlog.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default blogSlice.reducer;
